import restRequestV3 from '@/utils/restRequestV3';

const BASE_URL = '/api/v3/users';

export default {
  // 用户注册
  register(data) {
    return restRequestV3.post(`${BASE_URL}/register`, data);
  },

  // 用户登录
  login(data) {
    return restRequestV3.post(`${BASE_URL}/login`, data);
  },

  /**
   * 手机验证码登录
   * @param {Object} data 登录参数
   * @param {string} data.phone 手机号（必填）
   * @param {string} data.code 验证码（必填）
   * @param {number} [data.shareUserId] 分享用户ID（可选）
   * @param {number} [data.shareStoreId] 分享店铺ID（可选）
   * @returns {Promise<Object>} 登录结果，包含user、token、isNewUser等信息
   */
  phoneCodeLogin(data) {
    return restRequestV3.post(`${BASE_URL}/phone-code-login`, data);
  },

  // 微信小程序登录
  wechatMiniLogin(data) {
    return restRequestV3.post(`${BASE_URL}/wechat-mini-login`, data);
  },

  /**
   * 微信公众号登录 - 返回跳转URL (由微信服务器回调)
   * 注意：此接口由微信服务器回调，会自动重定向到前端页面
   * @param {Object} params 登录参数
   * @param {string} params.code 微信授权码
   * @param {string} [params.suffix] 子域名标识
   * @param {string} [params.appType] 应用类型
   * @param {string} [params.mode] 模式
   * @param {string} [params.returnPath] 返回路径
   * @param {number} [params.shareUserId] 分享用户ID
   * @param {number} [params.shareStoreId] 分享店铺ID
   * @returns {Promise} HTML重定向响应
   */
  
  wechatOfficialLogin(params) {
    const url = new URL('/api/v3/users/wechat-official-login', window.location.origin);
    
    // 添加查询参数
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        url.searchParams.append(key, params[key]);
      }
    });
    
    // 直接跳转到该URL，由微信服务器回调
    window.location.href = url.toString();
  },

  /**
   * 微信开放平台授权登录
   * @param {Object} data 登录数据
   * @param {String} data.accessToken 微信授权 access_token（必填）
   * @param {String} data.refreshToken 微信授权 refresh_token（必填）
   * @param {String} data.openid 微信用户的 openid（必填）
   * @param {Number} data.shareUserId 分享用户ID（可选）
   * @param {Number} data.shareStoreId 分享店铺ID（可选）
   * @returns {Promise<Object>} 登录结果，包含user、token、isNewUser等信息
   */
  wechatOpenPlatformLogin(data) {
    return restRequestV3.post(`${BASE_URL}/wechat-open-platform-login`, data);
  },

  // 发送短信验证码
  sendCode(phone) {
    return restRequestV3.post(`${BASE_URL}/send-code?phone=${phone}`);
  },

  // 获取用户资料
  getUserProfile() {
    return restRequestV3.get(`${BASE_URL}/profile`);
  },

  // 更新用户资料
  updateUserProfile(data) {
    return restRequestV3.put(`${BASE_URL}/profile`, data);
  },

  // 重置密码
  resetPassword(phone, code, newPassword) {
    return restRequestV3.post(`${BASE_URL}/reset-password`, {
      phone,
      code,
      newPassword
    });
  },

  // 绑定手机号
  bindPhone(phone, code) {
    return restRequestV3.post(`${BASE_URL}/bind-phone`, {
      phone,
      code
    });
  },

  // 刷新Token
  refreshToken(refreshToken) {
    return restRequestV3.post(`${BASE_URL}/refresh-token?refreshToken=${refreshToken}`);
  },

  /**
   * 通过一次性key获取登录信息
   * @param {string} key 一次性登录key
   * @returns {Promise} 登录结果
   */
     loginByKey(key) {
     return restRequestV3.post(`/api/v3/users/login-by-key?key=${key}`);
   }
}; 


// WEBPACK FOOTER //
// ./src/api/v3/user.js